import {
  ChromeExtensionMemoryTracker,
  LinuxMemoryTracker,
  MacMemoryTracker,
  WindowsMemoryTracker,
} from 'constants/memoryTracker';
import type { MemoryTracker } from 'types/memoryTracker';
import { getOS, OS } from './os-detection';

export function getRecommendedMemoryTracker(): MemoryTracker | null {
  const os = getOS();

  if (os === OS.Mac) {
    return MacMemoryTracker;
  } else if (os === OS.Windows) {
    return WindowsMemoryTracker;
  } else if (os === OS.Linux) {
    return LinuxMemoryTracker;
  } else if (isChromeExtensionPreferred()) {
    return ChromeExtensionMemoryTracker;
  } else {
    return null;
  }
}

function isChromeExtensionPreferred(): boolean {
  const ua = window.navigator.userAgent ?? '';
  return ua.includes('CrOS');
}

export function getTicCompatibleMemoryTracker(): MemoryTracker | null {
  const os = getOS();
  if (os === OS.Mac) {
    return MacMemoryTracker;
  }
  if (os === OS.Windows) {
    return WindowsMemoryTracker;
  }
  if (os === OS.Linux) {
    return LinuxMemoryTracker;
  }
  return null;
}
